module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sucsess"
  }, [_c('p', {
    staticClass: "sucsess__text"
  }, [_vm._v(_vm._s(_vm.text))]), _c('Button', {
    attrs: {
      "bordered": true
    },
    on: {
      "click": function($event) {
        return _vm.$emit('sucsess')
      }
    }
  }, [_vm._v(_vm._s(_vm.btnText))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-96076d62","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/certificate/components/sucsess/Sucsess.vue
// module id = 0a2d2d024751b0279568
// module chunks = 9